var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main page-btns" },
    [
      _c("div", { staticClass: "page_top" }, [
        _c(
          "div",
          { staticClass: "name" },
          [
            _vm._v("\n        Hi," + _vm._s(_vm.recipientName) + "\n        "),
            +_vm.$store.getters.userInfo.type === 0
              ? _c(
                  "el-button",
                  { attrs: { type: "text" }, on: { click: _vm.handleUpdate } },
                  [_vm._v("Modify")]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "send" },
          [
            +_vm.$store.getters.userInfo.type === 0
              ? _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.toSend } },
                  [
                    _c("svg-icon", { attrs: { "icon-class": "tn-msg" } }),
                    _vm._v("\n          Send\n        "),
                  ],
                  1
                )
              : _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.toSend } },
                  [
                    _c("svg-icon", { attrs: { "icon-class": "tn-msg" } }),
                    _vm._v("\n          Send to Producer\n        "),
                  ],
                  1
                ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "home-msg",
        },
        [
          _c("div", { staticClass: "home-msg_title spaceBetween" }, [
            _vm._v("\n        Message List\n        "),
            _c(
              "div",
              [
                _c(
                  "el-checkbox",
                  {
                    on: { change: _vm.getDataList },
                    model: {
                      value: _vm.hideReaded,
                      callback: function ($$v) {
                        _vm.hideReaded = $$v
                      },
                      expression: "hideReaded",
                    },
                  },
                  [_vm._v("Hide read")]
                ),
                _vm._v(" "),
                _c(
                  "loading-btn",
                  {
                    staticStyle: { "margin-left": "16px" },
                    attrs: { type: "text", label: "Mark all as read" },
                    on: { clickHandle: _vm.markAllRead },
                  },
                  [_c("svg-icon", { attrs: { "icon-class": "tn-readed" } })],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              staticClass: "home-msg_collapse",
              attrs: { accordion: "" },
              on: { change: _vm.changeOpen },
              model: {
                value: _vm.activeCollapse,
                callback: function ($$v) {
                  _vm.activeCollapse = $$v
                },
                expression: "activeCollapse",
              },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "el-collapse-item",
                {
                  key: index,
                  class: { "is-readed": +item.status !== 0 },
                  attrs: { name: item.msgID },
                },
                [
                  _c("template", { slot: "title" }, [
                    _c(
                      "div",
                      { staticClass: "spaceBetween home-msg_collapse_head" },
                      [
                        _c(
                          "div",
                          [
                            _c("svg-icon", {
                              staticClass: "icon-arrow",
                              attrs: { "icon-class": "tn-jiantou" },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.title))]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "time-text" }, [
                          _vm._v(_vm._s(_vm.moment(item.timestamp).fromNow())),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("pre", { staticClass: "msg-desc" }, [
                    _vm._v("  "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(item.description) },
                    }),
                    _vm._v("\n"),
                  ]),
                ],
                2
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.dataList.length == 0
            ? _c("div", { staticClass: "msg-empty" }, [_vm._v("No Data")])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-bottom-btn" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.queryParams.total,
                  page: _vm.queryParams.page,
                  limit: _vm.queryParams.eachpage,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.queryParams, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.queryParams, "eachpage", $event)
                  },
                  pagination: function ($event) {
                    return _vm.getDataList()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("updateName", { ref: "updateName", on: { success: _vm.setSuccess } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }